import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchCompany, updateCompanyGeekAI, fetchRookeryStatusInfo } from "../actions/index";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";
import CompanyGeekAIForm from "./CompanyGeekAIForm";

class CompanyGeekAI extends Component {
  static propTypes = {
    fetchCompany: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    fetchRookeryStatusInfo: PropTypes.func.isRequired,
    company: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { enabled: true };
  }

  componentDidMount() {
    this.props.fetchCompany();
    this.props
      .fetchRookeryStatusInfo()
      .then(response => {
        if (response.payload.data.data.rookery_enabled) {
          this.fetchData();
        } else {
          this.setState({ enabled: false });
        }
      });
  }

  handleSaveSources(state) {
    this.props
      .updateCompanyGeekAI(state)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Settings saved!");
        }
      });
  }

  render() {
    if (this.props.company == undefined) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    if (this.state.enabled == false) {
      return (
        <div>
          <h1>Geek AI: Automated Assistant</h1>
          <div className="row">
            <div className="m-t-20">
              <div className="alert alert-success">
                <h4 className="dns-change-required">
                  <strong>You&#39;re Almost There! </strong>
                  You must first enable text messaging to use Geek AI
                  <br />
                  <a href="https://leads.realgeeks.com/preferences/text_messaging">
                    Click here to enable text messaging.
                  </a>
                </h4>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <h1>Geek AI: Automated Assistant</h1>
        <h3 className=""> Settings </h3>
        <CompanyGeekAIForm
          handleSaveSources={this.handleSaveSources.bind(this)}
          company={this.props.company.data}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { company: state.company.company };
}

export default connect(
  mapStateToProps,
  { fetchCompany, updateCompanyGeekAI, fetchRookeryStatusInfo }
)(CompanyGeekAI);
